import { Link } from 'react-router-dom';

const suitableList = [
  '想建立自有保健食品品牌，但缺乏生產設備',
  '已有品牌，需要穩定且高品質的代工夥伴',
  '想快速推出新品項，縮短產品開發時程',
  '需要多種劑型選擇，滿足不同產品線需求',
  '希望獲得法規送審與標示設計一站式服務',
  '計畫拓展海外市場，需要符合出口規範的產品',
  '有獨特配方構想，需要專業團隊協助實現',
  '想快速增加產品項目，擴大產品支線',
];

export default function SuitableForSection() {
  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          {/* Left text */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">
              適合對象
            </span>
            <h2 className="text-[#1a2e1a] font-bold leading-tight mb-6">
              哪些品牌適合<br />與康永合作？
            </h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] mb-8">
              如果您符合以下任一描述，康永生技就是您理想的代工夥伴：
            </p>

            <div className="space-y-3 mb-8">
              {suitableList.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg" />
                  </div>
                  <span className="text-[#1a2e1a] text-[0.9375rem] leading-[1.75]">{item}</span>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <Link
                to="/contact"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-7 py-4 rounded-full transition-all duration-300 cursor-pointer"
              >
                立即諮詢是否適合合作
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          {/* Right image */}
          <div className="w-full lg:w-1/2 flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20bright%20supplement%20manufacturing%20facility%20interior%20with%20large%20windows%20shelves%20full%20of%20products%2C%20clean%20professional%20health%20food%20production%20environment%2C%20workers%20in%20white%20uniforms%2C%20natural%20daylight&width=720&height=540&seq=suitable-img-01&orientation=landscape"
                alt="適合合作對象"
                className="w-full h-[360px] lg:h-[460px] object-cover object-top rounded-2xl"
              />
              <div className="absolute bottom-5 left-5 bg-white/95 rounded-xl px-5 py-4 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-green-50 rounded-lg">
                  <i className="ri-user-heart-line text-[#4CAF50] text-xl" />
                </div>
                <div>
                  <p className="text-[#1a2e1a] font-bold text-[0.9375rem]">250+ 品牌信賴</p>
                  <p className="text-gray-400 text-[0.75rem]">涵蓋各類型合作夥伴</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
